import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { ShoppingCart, Report } from "@mui/icons-material";
import { Order } from "../../../../orders/utils/types";
import { useTranslation } from "../../../../../hooks/useTranslation";
import { useOrderPurchase } from "../../../../../hooks/useOrderPurchase";

type Props = {
  order: Order;
};

export const OrderAction = ({ order }: Props) => {
  const { translate } = useTranslation("pages.orders");
  const { hasAddress, handlePurchase } = useOrderPurchase(order);

  const actionItem = (
    <ListItemButton onClick={handlePurchase} disabled={!hasAddress}>
      <ListItemIcon>
        {hasAddress ? (
          <ShoppingCart color="primary" />
        ) : (
          <Report color="error" />
        )}
      </ListItemIcon>
      <ListItemText primary={translate("list.fields.purchase")} />
    </ListItemButton>
  );

  return hasAddress ? (
    actionItem
  ) : (
    <Tooltip title={translate("list.fields.noAddress")} placement="right">
      <span>{actionItem}</span>
    </Tooltip>
  );
};
